import { render, staticRenderFns } from "./PasswordResetModalWrapper.vue?vue&type=template&id=82835ae8"
import script from "./PasswordResetModalWrapper.vue?vue&type=script&lang=js"
export * from "./PasswordResetModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetModalWrapper.vue?vue&type=style&index=0&id=82835ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
